import { makeStyles } from '@material-ui/core/styles';

import { cardRadius, cardShadow, colors, typography } from '../../tokens';

const useStyles = makeStyles(theme => ({
  progressCard: {
    height: 300,
    padding: theme.spacing(3, 3.5),
    borderRadius: cardRadius,
    boxShadow: cardShadow,
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    color: colors.textPrimary,
    fontSize: typography.sectionTitle.fontSize,
    fontWeight: typography.sectionTitle.fontWeight,
  },
  sectionTotal: {
    color: colors.textPrimary,
    fontSize: typography.sectionTitle.fontSize,
    fontWeight: typography.sectionTitle.fontWeight,
  },
  progressRow: {
    cursor: 'pointer',
    display: 'grid',
    gridTemplateColumns: '190px 1fr 34px',
    gap: theme.spacing(2),
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  progressLabel: {
    color: colors.textSecondary,
    fontSize: typography.body.fontSize,
  },
  progressTrack: {
    position: 'relative',
    height: 12,
    borderRadius: 12,
    background: '#eeeeee',
    overflow: 'visible',
  },
  progressFill: {
    height: '100%',
    borderRadius: 12,
  },
  progressCount: {
    textAlign: 'right',
    color: colors.textPrimary,
    fontSize: typography.body.fontSize,
  },
  percentTooltip: {
    background: '#737373',
    color: '#fff',
    fontSize: 12,
    fontWeight: 700,
  },
  percentTooltipArrow: {
    color: '#737373',
  },
}));

export default useStyles;
